// extracted by mini-css-extract-plugin
export default {"TopHeaderMain":"MainHeader_TopHeaderMain__1kVBV","Network":"MainHeader_Network__62Xut"};